__turbopack_context__.v({
  "directionsLink": "MapView-module__16Jk4G__directionsLink",
  "error": "MapView-module__16Jk4G__error",
  "greyscale": "MapView-module__16Jk4G__greyscale",
  "iframe": "MapView-module__16Jk4G__iframe",
  "iframeWrap": "MapView-module__16Jk4G__iframeWrap",
  "info": "MapView-module__16Jk4G__info",
  "note": "MapView-module__16Jk4G__note",
  "osmLink": "MapView-module__16Jk4G__osmLink",
  "root": "MapView-module__16Jk4G__root",
});
